module.exports = __webpack_public_path__ + "img/main-directions.1f4c6fa2.webp";